import {
  BathroomEnum,
  FloorCoveringEnum,
  HeatingEnum,
  ResidentialAreaEnum,
  RoofCoveringEnum,
  StatusEnum,
  StoreRoomEnum,
  SurfaceMountedInstallationEnum,
  WindowsEnum,
} from "@/types/refineRealEstate";

export const defaultModernizationsMatrix = {
  interiorDesign: StatusEnum.none,
  sanitaryArea: StatusEnum.none,
  heatingSystem: StatusEnum.none,
  pipes: StatusEnum.none,
  windows: StatusEnum.none,
  thermalInsulation: StatusEnum.none,
  roofCoveringAndInsulation: StatusEnum.none,
  roomLayout: StatusEnum.none,
};

export const defaultEquipmentIndicators = {
  guestToilet: true,
  insulatedExteriorWalls: true,
  windows: WindowsEnum.doubleGlazing,
  heating: HeatingEnum.centralHeating,
  heatingSystem: false,
};

export const defaultEquipmentIndicatorsHouse = {
  storeRoom: undefined,
  bathroom: BathroomEnum.oneBath,
  sauna: false,
  roofCovering: RoofCoveringEnum.roofingTiles,
  floorCovering: undefined,
  surfaceMountedInstallation: SurfaceMountedInstallationEnum.cablesNotOnWalls,
  fireplace: false,
  residentialArea: undefined,
  level: undefined,
};

export const defaultEquipmentIndicatorsApartment = {
  storeRoom: StoreRoomEnum.none,
  bathroom: BathroomEnum.withWindow,
  wellnessFeatures: undefined,
  roofCovering: undefined,
  floorCovering: FloorCoveringEnum.carpetLaminate,
  surfaceMountedInstallation: undefined,
  fireplaceSolarThermalEnergy: undefined,
  residentialArea: ResidentialAreaEnum.balconyUnder10,
  level: undefined,
};
export const defaultEquipmentIndicatorsMultifamilyHouse = {
  storeRoom: StoreRoomEnum.none,
  bathroom: undefined,
  wellnessFeatures: undefined,
  roofCovering: RoofCoveringEnum.roofingTiles,
  floor: undefined,
  surfaceMountedInstallation: undefined,
  fireplaceSolarThermalEnergy: undefined,
  residentialArea: ResidentialAreaEnum.balconyUnder10,
  level: undefined,
};
